import React, { useContext } from 'react';
import {
  abortableFetch,
  DetailContext,
  DetailToolbarButton2,
} from '@eas/common-web';
import { GetApp } from '@material-ui/icons';
import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';

const useCurrentDetailId = () => {
  const location = useLocation();

  const id = location.pathname.split('/').pop();
  return id;
};

const exportFetch = async (id: string) => {
  const res = abortableFetch(`/api/tapis/import-request/${id}/export`);

  const response = await res.response;
  const blob = await response.blob();
  const fileUrl = URL.createObjectURL(blob);

  return fileUrl;
};

const useExport = () => {
  return useMutation(exportFetch);
};

export function ImportRequestToolbarExport() {
  const { isExisting: isDetail } = useContext(DetailContext);
  const { mutate, isLoading } = useExport();
  const id = useCurrentDetailId();

  const onExport = () => {
    if (!id) return;

    mutate(id, {
      onSuccess: (data) => {
        window.open(data, '_blank');
      },
    });
  };

  return isDetail ? (
    <DetailToolbarButton2
      startIcon={
        isLoading ? (
          <CircularProgress size="20px" color="inherit" />
        ) : (
          <GetApp />
        )
      }
      disabled={isLoading}
      label="Export"
      onClick={onExport}
    />
  ) : null;
}
